export default __webpack_public_path__ + "static/media/team68.a481a649.JPG";